import React from "react";
import { UiButton, UiDrawer } from "../../../../components";
import { formatPhoneNumber } from "../../../../utils/appUtils";
import RejectLawyerModal from "../RejectLawyerModal";
import ApproveLawyerModal from "../ApproveLawyerModal";
import { userIcon } from "../../../../assets/images";
import { Modal } from "antd";
import "../LawyerProfileView/style.scss";

const EditRequestCompareDrawer = ({
    isVisible,
    onClose,
    currentLawyerDetails,
    requestedLawyerDetails,
    editableRequestFields,
    isApproveRejectLoading,
    isRejectModalOpen,
    isApproveModalOpen,
    reason,
    handleReasonChange,
    handleRejectClick,
    handleApproveClick,
    handleRejectSubmit,
    handleApproveConfirm,
    handleCloseRejectModal,
    handleCloseApproveModal,
    profileImageUrl,
    profileModalOpen,
    handleProfileModalOpen,
    handleProfileModalClose
}) => {
    const getDisplayValue = (value) => {
        if (Array.isArray(value)) {
            return value?.length > 0 ? value?.join(", ") : "Nil";
        }
        return value || value === 0 ? `${value}` : "Nil";
    };

    const changedRows = editableRequestFields
        ?.map((fieldName) => ({
            field: fieldName,
            currentValue: getDisplayValue(currentLawyerDetails?.[fieldName]),
            requestedValue: getDisplayValue(requestedLawyerDetails?.[fieldName])
        }))
        ?.filter((comparisonDetail) => comparisonDetail?.currentValue !== comparisonDetail?.requestedValue);
    if (!isVisible) {
        return null;
    }
    
    return (
        <>
            <UiDrawer
                open={isVisible}
                onClose={onClose}
                title="Edit Request Details"
                width={650}
                footer={
                    <div style={{ display: "flex", justifyContent: "flex-end", gap: "12px", width: "100%" }}>
                        <UiButton
                            type="primary"
                            danger
                            onClick={handleRejectClick}
                            loading={isApproveRejectLoading}
                            disabled={isApproveRejectLoading}
                        >
                            Reject
                        </UiButton>
                        <UiButton
                            type="primary"
                            onClick={handleApproveClick}
                            loading={isApproveRejectLoading}
                            disabled={isApproveRejectLoading}
                        >
                            Approve
                        </UiButton>
                    </div>
                }
            >
                <div className="lawyer-information" style={{ marginBottom: "12px" }}>
                    <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                        <div className="flexible">
                            {
                                !profileImageUrl || profileImageUrl?.includes("null") || profileImageUrl?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover", cursor: "pointer" }} alt="" onClick={handleProfileModalOpen} /> : <img
                                    src={profileImageUrl}
                                    onClick={handleProfileModalOpen}
                                    alt=""
                                    className="profile-image"
                                    style={{ cursor: "pointer" }}
                                />
                            }
                            <div>
                                <h3 className="lawerInfo-detail" style={{ marginTop: "15px" }}>
                                    {currentLawyerDetails?.salutation} {currentLawyerDetails?.firstName} {currentLawyerDetails?.middleName} {currentLawyerDetails?.lastName}
                                </h3>
                            </div>
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">Mobile Number</small>
                            <h3 className="lawerInfo-detail">{currentLawyerDetails?.mobileNumber ? formatPhoneNumber(currentLawyerDetails?.mobileNumber) : "Nil"}</h3>
                        </div>
                        <div>
                            <small className="information-header">E-mail Address</small>
                            <h3 className="lawerInfo-detail">{currentLawyerDetails?.email || "Nil"}</h3>
                        </div>
                    </div>
                </div>
                <div style={{ marginTop: "12px", border: "1px solid #f0f0f0", borderRadius: "8px", overflow: "hidden" }}>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", padding: "10px 12px", backgroundColor: "#f7f7f7", borderBottom: "1px solid #ececec" }}>
                        <span style={{ fontWeight: 600 }}>Field</span>
                        <span style={{ fontWeight: 600 }}>Current</span>
                        <span style={{ fontWeight: 600, textAlign: "right" }}>Requested</span>
                    </div>
                    {changedRows?.length > 0 ? changedRows?.map((comparisonDetail, index) => (
                        <div
                            key={`${comparisonDetail?.field}-${index}`}
                            style={{
                                display: "grid",
                                gridTemplateColumns: "1fr 1fr 1fr",
                                gap: "12px",
                                padding: "10px 12px",
                                borderBottom: index === changedRows?.length - 1 ? "none" : "1px solid #f5f5f5",
                                backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa"
                            }}
                        >
                            <span>{comparisonDetail?.field}</span>
                            <span>{comparisonDetail?.currentValue}</span>
                            <span style={{ textAlign: "right" }}>{comparisonDetail?.requestedValue}</span>
                        </div>
                    )) : <div style={{ padding: "12px", textAlign: "center", backgroundColor: "#fff" }}>No changes</div>}
                </div>
            </UiDrawer>
            <Modal
                open={profileModalOpen}
                onCancel={handleProfileModalClose}
                footer={null}
                centered
                className="custom-image-modal"
                closeIcon={<span style={{ fontSize: 24, color: "#fff" }}>×</span>}
            >
                <div style={{ padding: "20px 0px" }}>
                    {profileImageUrl ? (
                        <img
                            src={profileImageUrl}
                            alt={`${currentLawyerDetails?.firstName || ""} ${currentLawyerDetails?.middleName || ""} ${currentLawyerDetails?.lastName || ""}`.trim() || "Lawyer"}
                            style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "cover" }}
                        />
                    ) : (
                        <div className="profile-avatar profile-placeholder" aria-hidden="true" style={{ width: "100%", height: "300px" }} />
                    )}
                </div>
            </Modal>
            <RejectLawyerModal
                isVisible={isRejectModalOpen}
                onClose={handleCloseRejectModal}
                onSubmit={handleRejectSubmit}
                lawyerName={`${currentLawyerDetails?.firstName || ""} ${currentLawyerDetails?.middleName || ""} ${currentLawyerDetails?.lastName || ""}`.trim()}
                isLoading={isApproveRejectLoading}
                reason={reason}
                handleReasonChange={handleReasonChange}
            />
            <ApproveLawyerModal
                isVisible={isApproveModalOpen}
                onClose={handleCloseApproveModal}
                onConfirm={handleApproveConfirm}
                lawyerName={`${currentLawyerDetails?.firstName || ""} ${currentLawyerDetails?.middleName || ""} ${currentLawyerDetails?.lastName || ""}`.trim()}
                isLoading={isApproveRejectLoading}
            />
        </>
    );
};

export default EditRequestCompareDrawer;
